import App from './App.vue';

export default {
  path: '/CDS_VF_LifelineNetworkDetail',
  name: 'CDS_VF_LifelineNetworkDetail',
  component: App,
  meta: {
    pageProperty: {
      title: 'ライフライン(通信)',
      controller: 'CDS_CTR_LifelineNetworkDetail',
    },
  },
};
